import { Collapse, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Toolbar } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import SVG1 from "../../media/images/logo.png";
import {
  AdvertiseNew,
  BuyBonusIcon,
  CloseIcon,
  CustomerIcon,
  DashboardIcon,
  DistributorNew,
  DropdownIcone,
  DropdownUpIcone,
  InvoiceIcone,
  KioskNew,
  LockIcon,
  LocationIcon,
  MenuIcon,
  MGMIcon,
  OperatorNew,
  PaypalIcone,
  PromoIcon,
  ScratchEvent,
  SettingIcone,
  SubmenuIcone,
  TransactionIcon,
  TransactionNew,
  UserNew
} from "../../components/Icons";
import { findUserAccess } from "../../utils/UserAccess";
import { useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { useState } from "react";
import { moduleName } from "../../utils/moduleName";

export default function DrawerContents({ toggled, onClick }) {
  const location = useLocation();
  const { palette } = useTheme();
  const { user } = useSelector((state) => state.auth);
  const UserAccess = (value) => {
    return findUserAccess(value, user.userRole);
  };
  const CUSTOMER_LIST_ACCESS = UserAccess("customer_list");
  const BONUS_ACCESS = UserAccess("bonus_data");

  function MenuItem({ title, to, icon, isActive = [], subMenu, children }) {
    const [open, setOpen] = useState(isActive?.some((x) => x === location.pathname.split("/")[1]));
    // const [open, setOpen] = useState(false);
    return (
      <>
        <ListItemButton
          key={title}
          title={title}
          selected={isActive?.findIndex((x) => x === location.pathname.split("/")[1]) > -1}
          disableRipple
          onClick={subMenu ? () => setOpen(!open) : () => (window.innerWidth > 900 ? null : onClick())}
          component={subMenu ? "button" : Link}
          to={to}
          sx={{
            padding: "8px 23px !important",
            width: "100%",
            background:
              isActive?.findIndex((x) => x === location.pathname.split("/")[1]) > -1
                ? `${palette.mode === "light" ? palette.secondary.main : palette.background.default} !important`
                : "transparent"
          }}
        >
          {icon && (
            <ListItemIcon
              sx={{
                minWidth: "40px",
                color:
                  isActive?.findIndex((x) => x === location.pathname.split("/")[1]) > -1
                    ? `${palette.mode === "light" ? palette.dark.main : palette.primary.main} !important`
                    : palette.grey.main
              }}
            >
              {icon}
            </ListItemIcon>
          )}
          <ListItemText
            primary={title}
            className="ellipsis"
            sx={{
              fontSize: "16px",
              color:
                isActive?.findIndex((x) => x === location.pathname.split("/")[1]) > -1
                  ? `${palette.primary.main} !important`
                  : ""
            }}
          />
          {subMenu && <> {open ? <DropdownIcone /> : <DropdownUpIcone />}</>}
        </ListItemButton>
        {subMenu && (
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" className="submenu">
              {children}
            </List>
          </Collapse>
        )}
      </>
    );
  }
  const { promoCode, mgmList, fishJackpot, buyBonusList, subscription, scratchEvent, couponCode, loginHistory } =
    moduleName;

  return (
    <>
      <Toolbar
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: toggled ? "20px !important" : "15px !important"
        }}
      >
        {toggled && <img src={SVG1} alt="" width={180} />}
        <IconButton onClick={onClick}>{window.innerWidth > 900 && toggled ? <MenuIcon /> : <CloseIcon />}</IconButton>
      </Toolbar>
      <List component="div">
        <MenuItem title="Dashboard" to="/dashboard" isActive={[``]} icon={<DashboardIcon />} />
        {UserAccess("user_list") && <MenuItem title="Users" to="/users" isActive={[`users`]} icon={<UserNew />} />}
        {UserAccess("invoice_list") && user?.userType !== "operator" && user?.userType !== "operator_user" && (
          <MenuItem
            title="Invoices"
            icon={<InvoiceIcone />}
            isActive={[`invoices-list`, `invoices-overview`, "invoices"]}
            subMenu={true}
            children={
              <>
                <MenuItem
                  title="Invoices List"
                  to="/invoices-list"
                  isActive={[`invoices-list`]}
                  icon={<SubmenuIcone />}
                />
                <MenuItem
                  title="Invoices Overview"
                  to="/invoices-overview"
                  isActive={[`invoices-overview`]}
                  icon={<SubmenuIcone />}
                />
              </>
            }
          />
        )}
        {UserAccess("view_bill") && user?.userType !== "superAdmin" && user?.userType !== "superUser" && (
          <MenuItem
            title="Payable"
            icon={<PaypalIcone />}
            isActive={[`payable-list`, `payable-overview`, `payable-statements`]}
            subMenu={true}
            children={
              <>
                <MenuItem title="Payable List" to="/payable-list" isActive={["payable-list"]} icon={<SubmenuIcone />} />
                <MenuItem
                  title="Payable Overview"
                  to="/payable-overview"
                  isActive={["payable-overview"]}
                  icon={<SubmenuIcone />}
                />
                {/* <MenuItem
                  title="Payable Statements"
                  to="/payable-statements"
                  isActive={["payable-statements"]}
                  icon={<SubmenuIcone />}
                /> */}
              </>
            }
          />
        )}
        {UserAccess("collection_invoice_list") && (
          <MenuItem
            title="Collection Invoices"
            to="/collection-invoice"
            isActive={[`collection-invoice`]}
            icon={<PaypalIcone />}
          />
        )}
        {UserAccess("distributor_list") && (
          <MenuItem title="Distributors" to="/distributors" isActive={[`distributors`]} icon={<DistributorNew />} />
        )}
        {UserAccess("operator_list") && (
          <MenuItem title="Operators" to="/operators" isActive={[`operators`]} icon={<OperatorNew />} />
        )}
        {UserAccess("location_list") && (
          <MenuItem title="Locations" to="/locations" isActive={[`locations`]} icon={<LocationIcon />} />
        )}
        {CUSTOMER_LIST_ACCESS && !BONUS_ACCESS && (
          <MenuItem title="Players" to="/customers" isActive={[`customers`]} icon={<CustomerIcon />} />
        )}
        {CUSTOMER_LIST_ACCESS && BONUS_ACCESS && (
          <MenuItem
            title="Players"
            icon={<CustomerIcon />}
            isActive={[`customers`, `bonus`, "referral"]}
            subMenu={true}
            children={
              <>
                <MenuItem title="Player List" to="/customers" isActive={[`customers`]} icon={<SubmenuIcone />} />
                <MenuItem title="Bonus" to="/bonus" isActive={[`bonus`]} icon={<SubmenuIcone />} />
                <MenuItem title="Referral" to="/referral" isActive={[`referral`]} icon={<SubmenuIcone />} />
              </>
            }
          />
        )}
        {UserAccess("transaction_list") && (
          <MenuItem title="Transactions" to="/transactions" isActive={[`transactions`]} icon={<TransactionIcon />} />
        )}
        {UserAccess("advertisement_list") && (
          <MenuItem title="Advertises" to="/advertises" isActive={[`advertises`]} icon={<AdvertiseNew />} />
        )}
        {UserAccess("kiosk_model_list_tId") && (
          <MenuItem title="Terminals ID" to="/kiosks" isActive={[`kiosks`]} icon={<KioskNew />} />
        )}
        {UserAccess("promo_offer_list") && (
          <MenuItem title={promoCode} to="/promo-referral" isActive={[`promo-referral`]} icon={<PromoIcon />} />
        )}
        {UserAccess("mgm_list") && (
          <MenuItem title={mgmList} to="/mgm-list" isActive={[`mgm-list`]} icon={<MGMIcon />} />
        )}
        {UserAccess("fish_jackpot_list") && (
          <MenuItem title={fishJackpot} to="/fish-jackpot" isActive={[`fish-jackpot`]} icon={<MGMIcon />} />
        )}
        {UserAccess("bonus_purchase_list") && (
          <MenuItem title={buyBonusList} to="/buy-bonus-list" isActive={[`buy-bonus-list`]} icon={<BuyBonusIcon />} />
        )}
        {UserAccess("subscription_list") && (
          <MenuItem
            title={subscription}
            icon={<TransactionNew />}
            isActive={[`subscription`, "subscription-history"]}
            subMenu={true}
            children={
              <>
                <MenuItem
                  title={`${subscription} Plans`}
                  to="/subscription"
                  isActive={[`subscription`]}
                  icon={<SubmenuIcone />}
                />
                <MenuItem
                  title={`${subscription} History`}
                  to="/subscription-history"
                  isActive={[`subscription-history`]}
                  icon={<SubmenuIcone />}
                />
              </>
            }
          />
        )}
        {UserAccess("scratch_event_list") && (
          <MenuItem
            title={scratchEvent}
            icon={<ScratchEvent />}
            isActive={[`scratch-event`, "scratch-event-history"]}
            subMenu={true}
            children={
              <>
                <MenuItem
                  title={`${scratchEvent}`}
                  to="/scratch-event"
                  isActive={[`scratch-event`]}
                  icon={<SubmenuIcone />}
                />
                <MenuItem
                  title={`${scratchEvent} History`}
                  to="/scratch-event-history"
                  isActive={[`scratch-event-history`]}
                  icon={<SubmenuIcone />}
                />
              </>
            }
          />
        )}
        {UserAccess("coupon_code_list") && (
          <MenuItem title={couponCode} to="/coupon-code" isActive={[`coupon-code`]} icon={<PromoIcon />} />
        )}

        {/* {UserAccess("statement_list") && (
          <MenuItem title="Statements" to="/statements" isActive={["statements"]} icon={<StatementsIcone />} />
        )} */}
        {user?.userType === "superAdmin" && (
          <MenuItem title={loginHistory} to="/login-history" isActive={["login-history"]} icon={<LockIcon />} />
        )}
        {user?.userType === "superAdmin" && (
          <MenuItem title="Settings" to="/settings" isActive={["settings"]} icon={<SettingIcone />} />
        )}
      </List>
    </>
  );
}
